import styled, { css } from 'styled-components'
import { media } from 'utils/styleUtils'
import {
  MERCURY_GRAY,
  STACK_GRAY,
  DOVE_GRAY,
  ARMADILLO_BLACK,
} from 'constants/colors'
import YouTube from './Icons/YouTube'
import Facebook from './Icons/Facebook'
import Weibo from './Icons/Weibo'
import Youku from './Icons/Youku'
import Mail from './Icons/Mail'
import Tel from './Icons/Tel'

export const Container = styled.footer`
  padding: 2rem 0 1rem;
  background-color: ${MERCURY_GRAY};
  color: ${STACK_GRAY};

  a {
    color: inherit;

    :hover {
      text-decoration: underline;
    }
  }

  ${media.pad} {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
`

export const LinkColumnContainer = styled.div`
  width: 100%;
  max-width: 1080px;
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
`

const LinkColumn = styled.div`
  display: inline-block;
  padding: 0.5rem 1rem;
  width: 50%;
  vertical-align: top;
  text-align: center;
  li {
    padding-bottom: 0.2rem;
    font-size: 0.9rem;
  }

  ${media.pad} {
    width: auto;
    max-width: 50%;
    padding-left: 0.6rem;
    padding-right: 0.6rem;
    text-align: left;
  }
`

export const AboutSection = LinkColumn

export const HelpSection = LinkColumn

export const ContactSection = LinkColumn

export const LanguageSection = LinkColumn

export const SectionTitle = styled.h3`
  margin-bottom: 0.5rem;
  font-size: 1.1rem;
  color: ${DOVE_GRAY};
`

export const SocialMediaIcons = styled.li`
  a {
    margin: 0 0.125rem;
  }

  ${media.pad} {
    a {
      margin-left: 0;
      margin-right: 0.25rem;
    }
  }
`

export const SocialMediaIcon = {}
const socialMediaIconStyles = fill => css`
  display: inline-block;
  width: 36px;
  height: 36px;

  :hover {
    fill: ${fill};
  }
`

SocialMediaIcon.YouTube = styled(YouTube)`
  ${socialMediaIconStyles('#e32c27')}
`
SocialMediaIcon.Facebook = styled(Facebook)`
  ${socialMediaIconStyles('#39579a')}
`
SocialMediaIcon.Weibo = styled(Weibo)`
  ${socialMediaIconStyles('#e90e24')}
`
SocialMediaIcon.Youku = styled(Youku)`
  ${socialMediaIconStyles('#00a5e2')}
`

export const ContactUsIcon = {}
const contactUsIconStyles = css`
  display: none;
  width: 20px;
  height: 20px;
  vertical-align: middle;
  margin-right: 0.5rem;

  ${media.pad} {
    display: inline-block;
  }
`
ContactUsIcon.Mail = styled(Mail)`
  ${contactUsIconStyles}
`
ContactUsIcon.Tel = styled(Tel)`
  ${contactUsIconStyles}
`

export const ServiceHour = styled.div`
  margin-top: 0.2rem;
`

export const ExtraInfo = styled(LinkColumnContainer)`
  flex-direction: column;
  justify-content: center;
  margin-top: 3rem;
  padding-top: 1rem;
  text-align: center;
  font-size: 0.8rem;
  &,
  a {
    color: ${ARMADILLO_BLACK};
  }
`
